module.exports = __webpack_public_path__ + "static/img/thumb-02.f3462b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/thumb/thumb-02.png
// module id = cfVa
// module chunks = 150